module.exports = __webpack_public_path__ + "media/images/banner/planning/zh-hans-b792d5cf7e7265a824f4c9ec52b5340a.jpg";